import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/plugins/store'
import './registerServiceWorker'
// @ts-ignore: Unreachable code error
import vuetify from '@/plugins/vuetify'
import moment from 'moment'
// @ts-ignore: Unreachable code error
import money from 'v-money'
// @ts-ignore: Unreachable code error
import VueTheMask from 'vue-the-mask'
// @ts-ignore: Unreachable code error
import VueHtmlToPaper from 'vue-html-to-paper'
// @ts-ignore: Unreachable code error
import VueQrcode from '@chenfengyuan/vue-qrcode'
// @ts-ignore: Unreachable code error
import VueBarcode from '@xkeshi/vue-barcode'
// @ts-ignore: Unreachable code error
import JsonExcel from 'vue-json-excel'

Vue.component('downloadExcel', JsonExcel)
Vue.component(VueBarcode.name, VueBarcode);
Vue.component(VueQrcode.name, VueQrcode)

Vue.use(VueTheMask)
Vue.use(money, {precision: 4})
Vue.config.productionTip = false
Vue.prototype.moment = moment
const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
}

Vue.use(VueHtmlToPaper, options)
new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount ('#app');
